// Registers public/sw.js — production builds only, mirroring Diver's Horizon's convention (`npm start`'s
// dev server can't exercise the subscribe flow; test against `npm run build` or the deployed site).
export function register() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.error("Service worker registration failed", err);
    });
  });
}
